const config = {
  defaultLocale: "en",
  defaultPrefix: false,
  locales: ["en", "zh"],
}

export default config
